import React from 'react';
import InputField from '../Forms/InputField';
import ImageInput from '../Forms/ImageInput';

export default function PersonalDetails({ personalFields, setPersonalFields, image, setImage, setImageBase64 }) {

  const handleChange = (index, newValue) => {
    setPersonalFields(prevFields =>
      prevFields.map((field, i) =>
        i === index ? { ...field, value: newValue } : field
      )
    );
  };

  // Prepare visible fields with original indices so we can update the correct field
  const visibleFields = personalFields
    .map((f, i) => ({ ...f, __idx: i }))
    .filter(f => !f.hidden);

  const rows = [];
  for (let i = 0; i < visibleFields.length; i += 3) {
    rows.push(visibleFields.slice(i, i + 3));
  }

  const renderField = (fieldObj) => {
    //If Field Label is 'Own Referral Code' or 'Referred By Code' then toUpperCase the value

    const idx = fieldObj.__idx;
    const field = personalFields[idx];
    if (field.label === 'Own Referral Code' || field.label === 'Referred By Code') {
      if (field.value)
        field.value = field.value.toUpperCase();
    }
    const commonProps = {
      label: field.label,
      name: field.name,
      value: field.type === 'date' && field.value ? new Date(field.value).toISOString().split('T')[0] : field.value,
      placeholder: field.placeholder,
      type: field.type,
      required: field.required,
      onChange: (e) => handleChange(idx, e.target.value),
      disabled: field.disabled,
      className: field.className || ''
    };
    if (field.data) {
      return <InputField key={idx} {...commonProps} data={field.data} />;
    }
    return <InputField key={idx} {...commonProps} />;
  };

  return (
    <div className="flex flex-col justify-center px-5 py-3 mt-0 w-full font-semibold bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
      <div className="flex gap-3 justify-between items-center">
        <div className="flex flex-col w-full">
          {rows.map((row, rIndex) => (
            <div className="flex flex-wrap gap-3 w-full" key={rIndex}>
              {row.map(f => renderField(f))}
            </div>
          ))}
        </div>
        <div className="flex flex-col justify-center items-end self-stretch my-auto w-[180px] basis-1/6">
          <ImageInput
            image={image}
            setImage={setImage}
            text={'Profile Picture'}
            setImageBase64={setImageBase64}
          />
        </div>
      </div>
    </div>
  );
}